module.exports = __webpack_public_path__ + "img/pht_video_tip.86acf7ad.png";